import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import AudioPlayerBar from "./AudioPlayerBar";
import { usePlayer } from "../context/PlayerContext";

export default function Layout() {
  const { track } = usePlayer();
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className={`flex-1 ${track ? "pb-28" : "pb-10"}`}>
        <Outlet />
      </main>
      <footer className="border-t border-white/5 mt-10 py-10 text-center">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <p className="font-serif text-2xl text-ivory">Shia<span className="text-[#B79C7B] italic">Tunes</span><span className="text-[#71717A] text-base align-top ml-1">.com</span></p>
          <p className="text-xs text-[#71717A] mt-2 tracking-wide">A dignified archive of majalis, nohay, marsiya and live broadcasts.</p>
          <p className="text-xs text-[#71717A] mt-6 overline">© {new Date().getFullYear()} — All rights reserved</p>
        </div>
      </footer>
      <AudioPlayerBar />
    </div>
  );
}
